import {Observable} from 'rxjs';

export abstract class CustomFamiliesAdapter {
    abstract load(code, professional): Observable<any[]>;
}
